<template>
  <a-config-provider :locale="locale">
    <template   v-slot:renderEmpty>
      <div style="text-align: center;padding:40px;">
        <img slot="image" src="@/assets/empty.svg" style="width: 62px;height: 40px;" />
        <p>{{$t('baseVO.empty')}}</p>
      </div>
    </template>
    <div id="app"
    >
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import zhCNLocale from 'ant-design-vue/es/locale-provider/zh_CN'
import enUSLocale from 'ant-design-vue/es/locale-provider/en_US'
import 'moment/locale/zh-cn'
import { AppDeviceEnquire } from '@/utils/mixin'

const zhCN = zhCNLocale && (zhCNLocale.default || zhCNLocale)
const enUS = enUSLocale && (enUSLocale.default || enUSLocale)

export default {
  mixins: [AppDeviceEnquire],
  data () {
    return {
      busy:true
    }
  },
  computed:{
    locale(){
      const currentLang = this.$i18n && this.$i18n.locale
      console.log("currentLang = >" ,currentLang)
      return currentLang === 'en-US' ? enUS : zhCN
    },
  },
  mounted () {
    this.initApproveNum()
  },
  methods:{
    initApproveNum(){
      console.log(this.$router)
    },
  }
}
</script>
<style>
  #app {
    height: 100%;
    min-width: 1280px;
  }
  .ant-form-item-required::after{

  }

  .vb > .vb-dragger {
    z-index: 5;
    width: 12px;
    right: 0;
  }

  .vb > .vb-dragger > .vb-dragger-styler {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: rotate3d(0,0,0,0);
    transform: rotate3d(0,0,0,0);
    -webkit-transition:
      background-color 100ms ease-out,
      margin 100ms ease-out,
      height 100ms ease-out;
    transition:
      background-color 100ms ease-out,
      margin 100ms ease-out,
      height 100ms ease-out;
    background-color: rgba(204, 204, 204,.5);
    margin: 5px 5px 5px 0;
    border-radius: 20px;
    height: calc(100% - 10px);
    display: block;
  }

  .vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgb(204, 204, 204);
  }

  .vb > .vb-dragger:hover > .vb-dragger-styler {
    background-color: rgb(204, 204, 204);
    margin: 0px;
    height: 100%;
  }

  .vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
    background-color: rgb(204, 204, 204);
    margin: 0px;
    height: 100%;
  }

  .vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgb(204, 204, 204);
  }


  .no_show_dragger  .vb-dragger {
    display: none !important;
  }

</style>
